import { PayloadAction, createSlice } from '@reduxjs/toolkit'

interface appInitialState {
  loading: boolean
}

const initialState: appInitialState = {
  loading: false,
}

const setLoading = (
  state: appInitialState = initialState,
  action: PayloadAction<boolean>
) => {
  return {
    ...state,
    loading: action.payload
  }
}

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setLoading
  }
})

export const appReducer = appSlice.reducer
export const appActions = appSlice.actions
